import React from "react";
import useInView from "../../../hooks/useInView";
import "./TarjetaDeServicioPostulate.css";
import { JobService } from "../types";

interface TarjetaDeServicioPostulateProps {
  service: JobService;
  delay?: number;
  animationClass?: string;
}

export default function TarjetaDeServicioPostulate({ service, delay = 0, animationClass = "" }: TarjetaDeServicioPostulateProps) {
  const [ref, inView] = useInView({ threshold: 0.3 });

  return (
    <div
      ref={ref}
      className={`service-card animate-card${inView ? " visible" : ""} ${animationClass}`}
      style={{ transitionDelay: `${delay}s` } as React.CSSProperties}
    >
      <h3 className="service-postulate-title">{service.title}</h3>
      <p className="service-postulate-text">{service.desc}</p>
    </div>
  );
}
